export default "__VITE_ASSET__b061fb56__"